import React from 'react';
import { useStyles, listTextStyles } from './ReceivableCard.styled';
import { Box, List, ListItem, ListItemText } from '@material-ui/core';

const ReceivableCard = ({ list }) => {
  const classes = useStyles();
  const listClasses = listTextStyles();

  return (
    <Box className={classes.invoiceCardContainer} data-cy="receivable-card">
      <List className={classes.list}>
        {list.map(
          (val, index) =>
            !val.hide && (
              <ListItem key={index} className={classes.listItem}>
                <ListItemText primary={val.label} secondary={val.value} classes={listClasses} />
              </ListItem>
            )
        )}
      </List>
    </Box>
  );
};

export default ReceivableCard;
